import React, { useMemo, useState } from 'react';
import { TextInput } from '@mantine/core';
import { SectionCard } from '../../shared/SectionCard/SectionCard';
import { asCurrency } from '../../shared/utils/dashboard-page.utils';
import { SectionKey } from '../../shared/types/dashboard-page.types';
import { MostCanceledProduct } from '../../../../services/reports/reports.service';
import classes from './most-cancelled-section.module.scss';

export type MostCancelledSectionProps = {
  collapsedSections: Record<SectionKey, boolean>;
  toggleSection: (section: SectionKey) => void;
  mostCanceledProducts: MostCanceledProduct[];
};

export const MostCancelledSection: React.FC<MostCancelledSectionProps> = ({
  collapsedSections,
  toggleSection,
  mostCanceledProducts,
}) => {
  const [search, setSearch] = useState('');

  const visibleProducts = useMemo(
    () => mostCanceledProducts.filter((row) => {
      const query = search.toLowerCase();
      return row.productName.toLowerCase().includes(query) || row.categoryName.toLowerCase().includes(query);
    }),
    [mostCanceledProducts, search],
  );

  return (
    <SectionCard
      title="המבוטלים ביותר"
      sectionKey="mostCancelled"
      collapsed={collapsedSections.mostCancelled}
      onToggle={() => toggleSection('mostCancelled')}
      titleExtra={<span className={classes.countBadge}>{`(${mostCanceledProducts.length} פריטים)`}</span>}
    >
      <TextInput
        className={classes.searchInput}
        placeholder="חיפוש לפי שם פריט, קטגוריה..."
        value={search}
        onChange={(event) => setSearch(event.currentTarget.value)}
        data-testid="dashboard-most-cancelled-search"
      />

      {visibleProducts.length === 0 ? (
        <p className={classes.emptyHint}>אין נתונים להצגה</p>
      ) : (
        <div className={classes.list}>
          {visibleProducts.map((row) => (
            <div key={row.productId} className={classes.card}>
              <div className={classes.cell}>
                <span className={classes.cellLabel}>סה"כ הוזמנו</span>
                <span className={classes.cellValue}>{row.orderedQuantity}</span>
              </div>
              <div className={classes.cell}>
                <span className={classes.cellLabel}>שם פריט</span>
                <span className={classes.cellValue}>{row.productName}</span>
              </div>
              <div className={classes.cell}>
                <span className={classes.cellLabel}>קטגוריה</span>
                <span className={classes.cellValue}>{row.categoryName}</span>
              </div>
              <div className={classes.cell}>
                <span className={classes.cellLabel}>עלות ביטול</span>
                <span className={`${classes.cellValue} ${classes.cellValueDanger}`}>{asCurrency(row.canceledAmount)}</span>
              </div>
              <div className={classes.cell}>
                <span className={classes.cellLabel}>כמות שבוטלה</span>
                <span className={classes.cellValue}>{row.canceledQuantity}</span>
              </div>
            </div>
          ))}
        </div>
      )}
    </SectionCard>
  );
};
